import React from 'react';

export default function CloseIcon(){
    return (
        <svg width="12" height="12" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M22.468 4.004L14.831 11.641L21.903 18.712C22.683 19.493 22.683 20.759 21.903 21.54C21.122 22.321 19.855 22.321 19.074 21.54L12.003 14.469L4.93202 21.54C4.14902 22.321 2.88402 22.321 2.10402 21.54C1.32302 20.759 1.32302 19.493 2.10402 18.712L9.17403 11.641L1.53703 4.004C0.757026 3.223 0.757026 1.95701 1.53703 1.17601C2.31903 0.395006 3.58502 0.395006 4.36602 1.17601L12.003 8.812L19.64 1.17601C20.421 0.395006 21.687 0.395006 22.468 1.17601C23.249 1.95701 23.249 3.223 22.468 4.004Z" fill="#7e8289"/>
        </svg>
    )
}